import React from 'react';
import PropTypes from 'prop-types';
import { PhysicalCard, Button } from '@paypalcorp/pp-react';
import { trackLink } from '../../lib/analytics-helper';

const Prompt = function (props) {
  const { message, buttonText, buttonLink, fptiText, isNewTab, id, isNNAWidget } = props;
  const clickAction = (link, isTarget) => {
    if (isNNAWidget) {
      props.guideClicked();
    } else {
      trackLink({ id: 'homePage', link: `${link}` });
      const target = isTarget ? '_blank' : '_self';
      window.open(buttonLink, target);
    }
  };
  return (
    <div className="prompt" id={`prompt-${id}`}>
      <PhysicalCard className="prompt-items">
        <div className="message">
          <strong>{message}</strong>
        </div>
        <Button
          theme="v2"
          size="sm"
          secondary
          className="prompt-button"
          aria-label={buttonText}
          onClick={() => clickAction(fptiText, isNewTab)}
        >
          {buttonText}
        </Button>
      </PhysicalCard>
    </div>
  );
};

Prompt.propTypes = {
  id: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonLink: PropTypes.string.isRequired,
  fptiText: PropTypes.string.isRequired,
  isNewTab: PropTypes.bool,
  isNNAWidget: PropTypes.bool,
  guideClicked: PropTypes.func.isRequired,
};
Prompt.defaultProps = {
  isNewTab: false,
};
export default Prompt;
